import { RegularBenefitVariant, RegularEffect } from '../../../../../typings'
import { FormulaRecap } from './Formula'
import { FreeShippingRecap } from './FreeShipping'
import { GiftRecap } from './Gift'
import { MaxPriceRecap } from './MaxPrice'
import { MaxShippingRecap } from './MaxShipping'
import { NominalLoyaltyRecap } from './NominalLoyalty'
import { NominalPriceRecap } from './NominalPrice'
import { NominalShippingRecap } from './NominalShipping'
import { PercentualLoyaltyRecap } from './PercentualLoyalty'
import { PercentualPriceRecap } from './PercentualPrice'
import { PercentualShippingRecap } from './PercentualShipping'
import { PriceTableRecap } from './PriceTable'

export type ReviewProps = {
  config: RegularEffect
}

export const REVIEW_RECAP_MAP: Record<
  RegularBenefitVariant,
  (props: ReviewProps) => JSX.Element | null
> = {
  [RegularBenefitVariant.Nominal]: NominalPriceRecap,
  [RegularBenefitVariant.NominalShipping]: NominalShippingRecap,
  [RegularBenefitVariant.Percentual]: PercentualPriceRecap,
  [RegularBenefitVariant.MaxPrice]: MaxPriceRecap,
  [RegularBenefitVariant.MaxShipping]: MaxShippingRecap,
  [RegularBenefitVariant.FreeShipping]: FreeShippingRecap,
  [RegularBenefitVariant.PercentualShipping]: PercentualShippingRecap,
  [RegularBenefitVariant.NominalLoyalty]: NominalLoyaltyRecap,
  [RegularBenefitVariant.Gift]: GiftRecap,
  [RegularBenefitVariant.PercentualLoyalty]: PercentualLoyaltyRecap,
  [RegularBenefitVariant.Formula]: FormulaRecap,
  [RegularBenefitVariant.PriceTable]: PriceTableRecap,
}
